import { promptLogin } from '@/services/app/mcd';
import { useEffect } from 'react';

type LoginProps = {
  onLogin: () => void;
  onError?: (error: Error) => void;
};

export const Login = ({ onLogin, onError }: LoginProps) => {
  useEffect(() => {
    promptLogin()
      .then(() => onLogin())
      .catch((error) => onError?.(error));
  }, []);

  return null;
};
